import React, { useState } from "react";
import moment from "moment";
import { useNotifications } from "../../services/Notifications/NotificationHooks.js";
import { JOKI } from "../../JOKI";

import "./notifications.scss";
import { Button, Icon, Modal } from "selfly-ui-react";

export default function Notifications(props) {
    const notes = useNotifications();
    const [noteCard, setNoteCard] = useState(false);

    const noShow = notes === null ? true : Array.isArray(notes) ? (notes.length === 0 ? true : false) : false;

    if (noShow === true) {
        if (noteCard) {
            setNoteCard(false);
        }
        return null;
    }

    const flags = notes.reduce(
        (flags, note) => {
            if (note.read === false) {
                flags.unread++;
            }
            if (note.level === "critical") {
                flags.critical = true;
            }
            return flags;
        },
        { unread: 0, critical: false }
    );

    function toggleNotificationCardView() {
        setNoteCard(!noteCard);
    }

    function closeNotificationModal() {
        setNoteCard(false);
    }

    return (
        <React.Fragment>
            <div
                className={`notifications-icon new ${flags.critical ? "critical" : ""}`}
                onClick={toggleNotificationCardView}
            >
                <Icon>{flags.unread > 0 ? "notifications_active" : "notifications"}</Icon>
                <span>{flags.unread}</span>
                <span className="total-notes"> / {notes.length}</span>
            </div>
            {noteCard === true && (
                <NotificationViewModal notifications={notes} onClose={closeNotificationModal} isOpen={noteCard} />
            )}
        </React.Fragment>
    );
}

function NotificationViewModal(props) {
    const [index, setIndex] = useState(0);

    const notes = props.notifications;

    function next() {
        if (index === notes.length - 1) {
            setIndex(0);
        } else {
            setIndex(index + 1);
        }
    }

    function prev() {
        if (index === 0) {
            setIndex(notes.length - 1);
        } else {
            setIndex(index - 1);
        }
    }

    const note = notes[index];

    function confirm() {
        JOKI.trigger({
            key: "clearNotification",
            to: "NotificationService",
            body: note.id,
        });
        setIndex(0);
    }

    function closeAll() {
        JOKI.trigger({
            key: "clearAllNotifications",
            to: "NotificationService",
        });
        setIndex(0);
    }

    if (props.isOpen && note.read === false) {
        JOKI.trigger({
            key: "readNotification",
            to: "NotificationService",
            body: note.id,
        });
    }

    const texts = note.text.split('\n');


    return (
        <Modal
            onClose={props.onClose}
            active={props.isOpen}
            title={`Notifications ${index + 1} / ${notes.length}`}
            className="notification-modal"
            type={note.level === "critical" ? "negative" : note.level === "warning" ? "attention" : "primary"}
        >
            <header className="notification-modal-header">
                <dl>
                    <dd>Level</dd>
                    <dt>{note.level}</dt>
                </dl>
                <dl>
                    <dd>Since</dd>
                    <dt>{moment(note.time).format("DD.MM.YYYY HH:mm:ss")}</dt>
                </dl>
            </header>

            <div className="notification-modal-text-container">{texts.map((txt, i) => (
                <p key={i}>{txt}</p>
            ))}</div>

            <footer className="notification-modal-footer">
                <Button icon="arrow_back" onClick={prev} />

                {note.closed !== true && (<Button icon="check" type="positive" onClick={confirm}>
                    Confirm
                </Button>)}

                {notes.length > 1 && note.close !== true && (
                    <Button icon="check" type="positive" onClick={closeAll} className="confirm-all">All</Button>
                )}

                <Button icon="arrow_forward" onClick={next} />
            </footer>
        </Modal>
    );
}
